import React from 'react'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const FlujoEfectivoFormGroup = ({ ...props }) => {
  const [flujosEfectivo, setFlujosEfectivo] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.FLUJOSEFECTIVO).then(({ data }) => {
      setFlujosEfectivo(data)
    })
  }, [])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {flujosEfectivo.map((x, k) => (
        <option key={k} value={x._id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(FlujoEfectivoFormGroup)
